import { ABLY_INFO } from '../../constant/ablyInfo';

export const convertDeeplinkToWebLink = (deeplink: string) => {
  if (deeplink.includes('ably://webview')) {
    return deeplink.split('ably://webview?url=https://m.a-bly.com')[1];
  }

  if (deeplink.includes('ably://screens')) {
    const searchParams = new URLSearchParams(deeplink.split('?')[1]);

    return `/screens?${searchParams.toString()}`;
  }

  if (deeplink.includes('ably://events')) {
    const eventSno = deeplink.split('events/')[1];
    return `/events/${eventSno ?? ''}`; // /events/1234, /events 허용
  }

  if (deeplink.includes('ably://markets')) {
    const marketSegment = deeplink.split('markets/')[1];
    const [path, query] = marketSegment.split('?');

    return query != null
      ? `/mobile/markets/${path}?${encodeURIComponent(query)}`
      : `/mobile/markets/${path}`;
  }

  if (deeplink.includes('ably://goods')) {
    const goodsSegment = deeplink.split('goods/')[1];
    const [path, query] = goodsSegment.split('?');

    return query != null
      ? `/goods/${path}?${encodeURIComponent(query)}`
      : `/goods/${path}`;
  }
  return ABLY_INFO.url;
};
